import { initVariantPanelToggle } from "common/variantPanels";

initVariantPanelToggle("data-product-benefits", "data-variant-benefits-panel", "data-product-benefits-heading");
